<div class="card" style="position: relative">
    <p-toast></p-toast>
    <span class="page-title"><i class="pi pi-credit-card page-title-icon"></i>Bank Reconciliations</span>
    <div class="mt-6">
        <p-tabView class="pt-8">

            <!-- ── Zinara Report Upload ─────────────────────────────────────── -->
            <p-tabPanel header="Zinara Report Upload">
                <div class="upload-section">
                    <div class="upload-header">
                        <p class="upload-description">
                            Upload Zinara report files for processing. Maximum file size is 10MB.
                        </p>
                    </div>

                    <div class="file-upload-container">
                        <div class="file-input-wrapper">
                            <input
                                type="file"
                                aria-label="Select file for Zinara report upload"
                                title="Select file for Zinara report upload"
                                (change)="onZinaraFileSelect($event)"
                                class="file-input"
                                [disabled]="isZinaraUploading"
                                #zinaraInput
                            />

                            <div class="file-input-display">
                                <div class="file-input-placeholder" *ngIf="!zinaraFile">
                                    <i class="pi pi-file text-primary placeholder-icon"></i>
                                    <p>Click to choose file or drag and drop</p>
                                    <p class="text-sm text-secondary">Maximum file size: 10MB</p>
                                </div>

                                <div class="file-selected" *ngIf="zinaraFile">
                                    <i class="pi pi-file text-primary selected-icon"></i>
                                    <span class="text-sm">{{ zinaraFile.name }}</span>
                                    <button
                                        type="button"
                                        class="remove-file-btn"
                                        title="Remove selected file"
                                        aria-label="Remove selected file"
                                        (click)="clearZinaraFile(); zinaraInput.value = ''"
                                        [disabled]="isZinaraUploading"
                                    >
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <p-progressBar
                            *ngIf="isZinaraUploading"
                            mode="indeterminate"
                            [style]="{ height: '6px' }"
                        />

                        <div class="upload-actions">
                            <button
                                type="button"
                                class="upload-button"
                                (click)="uploadZinaraFile()"
                                [disabled]="!zinaraFile || isZinaraUploading"
                                pButton
                            >
                                <i class="pi pi-upload mr-2"></i>
                                Upload File
                            </button>

                            <button
                                type="button"
                                class="clear-button"
                                (click)="clearZinaraFile(); zinaraInput.value = ''"
                                [disabled]="!zinaraFile || isZinaraUploading"
                                pButton
                                severity="secondary"
                                [outlined]="true"
                            >
                                <i class="pi pi-trash mr-2"></i>
                                Clear
                            </button>
                        </div>
                    </div>

                    <div class="instructions mt-4">
                        <h6 class="instructions-title">
                            <i class="pi pi-info-circle text-primary mr-2"></i>
                            Instructions
                        </h6>
                        <ul class="instructions-list">
                            <li>Maximum file size: 10MB</li>
                            <li>Only one file can be uploaded at a time</li>
                        </ul>
                    </div>
                </div>
            </p-tabPanel>

            <!-- ── Icecash File Uploads ─────────────────────────────────────── -->
            <p-tabPanel header="Icecash File Uploads">
                <div class="upload-section">
                    <div class="upload-header">
                        <p class="upload-description">
                            Upload sales CSV files (.csv) for Icecash report processing.
                            Maximum file size is 10MB.
                        </p>
                    </div>

                    <div class="file-upload-container">
                        <div class="currency-select-wrapper mb-3">
                            <label class="currency-label" for="bankPromoCurrency">Currency</label>
                            <p-dropdown
                                inputId="bankPromoCurrency"
                                [options]="currencies"
                                [(ngModel)]="promoCurrencyId"
                                optionLabel="label"
                                optionValue="value"
                                [disabled]="isPromoUploading"
                                placeholder="Select currency"
                            ></p-dropdown>
                        </div>

                        <div class="file-input-wrapper">
                            <input
                                type="file"
                                accept=".csv"
                                aria-label="Select CSV file for Icecash upload"
                                title="Select CSV file for Icecash upload"
                                (change)="onPromoFileSelect($event)"
                                class="file-input"
                                [disabled]="isPromoUploading"
                                #bankPromoInput
                            />

                            <div class="file-input-display">
                                <div class="file-input-placeholder" *ngIf="!promoFile">
                                    <i class="pi pi-file-excel text-primary placeholder-icon"></i>
                                    <p>Click to choose file or drag and drop</p>
                                    <p class="text-sm text-secondary">Supports .csv files up to 10MB</p>
                                </div>

                                <div class="file-selected" *ngIf="promoFile">
                                    <i class="pi pi-file-excel text-primary selected-icon"></i>
                                    <span class="text-sm">{{ promoFile.name }}</span>
                                    <button
                                        type="button"
                                        class="remove-file-btn"
                                        title="Remove selected file"
                                        aria-label="Remove selected file"
                                        (click)="clearPromoFile(); bankPromoInput.value = ''"
                                        [disabled]="isPromoUploading"
                                    >
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <p-progressBar
                            *ngIf="isPromoUploading"
                            mode="indeterminate"
                            [style]="{ height: '6px' }"
                        />

                        <div class="upload-actions">
                            <button
                                type="button"
                                class="upload-button"
                                (click)="uploadPromoFile()"
                                [disabled]="!promoFile || isPromoUploading"
                                pButton
                            >
                                <i class="pi pi-upload mr-2"></i>
                                Upload File
                            </button>

                            <button
                                type="button"
                                class="clear-button"
                                (click)="clearPromoFile(); bankPromoInput.value = ''"
                                [disabled]="!promoFile || isPromoUploading"
                                pButton
                                severity="secondary"
                                [outlined]="true"
                            >
                                <i class="pi pi-trash mr-2"></i>
                                Clear
                            </button>
                        </div>
                    </div>

                    <div class="instructions mt-4">
                        <h6 class="instructions-title">
                            <i class="pi pi-info-circle text-primary mr-2"></i>
                            Instructions
                        </h6>
                        <ul class="instructions-list">
                            <li>Supported file type: .csv</li>
                            <li>Maximum file size: 10MB</li>
                            <li>Files will be processed as multipart form data</li>
                            <li>Only one file can be uploaded at a time</li>
                        </ul>
                    </div>
                </div>
            </p-tabPanel>

            <!-- ── Automatic Allocation ────────────────────────────────────── -->
            <p-tabPanel header="Reconciliation">
                <div class="report-filters">
                    <div class="controls-wrapper">
                        <span class="p-input-icon-right">
                            <p-calendar
                                [(ngModel)]="dateFrom"
                                [placeholder]="'From Date'"
                                [iconDisplay]="'input'"
                                [showIcon]="true"
                                [disabled]="submittingAuto()"
                            ></p-calendar>
                        </span>
                    </div>
                    <div class="controls-wrapper">
                        <span class="p-input-icon-right">
                            <p-calendar
                                [(ngModel)]="dateTo"
                                [placeholder]="'To Date'"
                                [iconDisplay]="'input'"
                                [showIcon]="true"
                                [minDate]="dateFrom ?? undefined"
                                [disabled]="submittingAuto()"
                            ></p-calendar>
                        </span>
                    </div>
                    <div class="controls-wrapper button-wrapper">
                        <p-button
                            label="Search"
                            [text]="true"
                            [raised]="true"
                            severity="success"
                            class="report-action-button"
                            (onClick)="submitReconcile()"
                            [disabled]="!dateFrom || !dateTo || submittingAuto()"
                            [loading]="submittingAuto()"
                            icon="pi pi-search"
                        ></p-button>
                    </div>
                </div>
                <hr />
                <div class="table-container">
                    <p-table
                        [value]="reconcileResults()"
                        [scrollable]="true"
                        scrollHeight="400px"
                        styleClass="p-datatable-striped"
                        [tableStyle]="{ 'min-width': '50rem' }"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th rowspan="2">User</th>
                                <th colspan="2" class="text-center">Sales Summary</th>
                                <th colspan="2" class="text-center">Bank Summary</th>
                                <th colspan="2" class="text-center">Variance</th>
                            </tr>
                            <tr>
                                <th>USD</th>
                                <th>ZWL</th>
                                <th>USD</th>
                                <th>ZWL</th>
                                <th>USD</th>
                                <th>ZWL</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td style="min-width: 7rem">{{ row.user }}</td>
                                <td style="min-width: 7rem">{{ row.salesSummary?.usd | number:'1.2-2' }}</td>
                                <td style="min-width: 7rem">{{ row.salesSummary?.zwl | number:'1.2-2' }}</td>
                                <td style="min-width: 7rem">{{ row.bankSummary?.usd | number:'1.2-2' }}</td>
                                <td style="min-width: 7rem">{{ row.bankSummary?.zwl | number:'1.2-2' }}</td>
                                <td style="min-width: 7rem" [class.variance-negative]="row.variance?.usd < 0">{{ row.variance?.usd | number:'1.2-2' }}</td>
                                <td style="min-width: 7rem" [class.variance-negative]="row.variance?.zwl < 0">{{ row.variance?.zwl | number:'1.2-2' }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7" class="text-center p-4">
                                    No reconciliation data found.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Automatic Allocation">
                <div class="info-banner">
                    <i class="pi pi-info-circle info-banner-icon"></i>
                    <small>Select a bank to automatically match its unallocated transactions to agents. Matched transactions are shown below; anything that couldn't be matched appears on the Unallocated Transactions tab.</small>
                </div>
                <div class="controls-wrapper">
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Bank</label>
                        <p-dropdown [options]="banks()" [(ngModel)]="filterBank" (onChange)="runAutomaticAllocation()"
                            [disabled]="submittingAutomatic()" placeholder="Select Bank"
                            optionLabel="label" optionValue="value"></p-dropdown>
                    </div>
                </div>

                <div *ngIf="submittingAutomatic()" class="flex justify-content-center py-4">
                    <p-progressSpinner strokeWidth="4" [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
                </div>

                <div class="table-container" *ngIf="!submittingAutomatic()">
                    <p-table [value]="automaticAllocatedResults()" dataKey="id" styleClass="p-datatable-striped"
                        [paginator]="true" [rows]="10" responsiveLayout="scroll">
                        <ng-template pTemplate="caption">
                            <span class="text-sm text-color-secondary">
                                {{ automaticAllocatedResults().length }} allocated transaction(s)
                            </span>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Date</th>
                                <th>Reference</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Bank</th>
                                <th>Agent</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-tx>
                            <tr>
                                <td>{{ tx.transactionDate | date:'dd MMM yyyy' }}</td>
                                <td>{{ tx.reference }}</td>
                                <td>{{ tx.description }}</td>
                                <td>{{ tx.debit | number:'1.2-2' }}</td>
                                <td>{{ tx.credit | number:'1.2-2' }}</td>
                                <td>{{ tx.bank }}</td>
                                <td>{{ tx.user?.username }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7" class="text-center p-4">
                                    Select a bank to run automatic allocation.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>

            <!-- ── Unallocated Transactions ─────────────────────────────────── -->
            <p-tabPanel header="Unallocated Transactions">
                <div class="info-banner">
                    <i class="pi pi-info-circle info-banner-icon"></i>
                    <small>Transactions left over from the last automatic allocation run that could not be matched to an agent.</small>
                </div>

                <div class="table-container">
                    <p-table [value]="automaticUnallocatedResults()" dataKey="id" styleClass="p-datatable-striped"
                        [paginator]="true" [rows]="10" responsiveLayout="scroll">
                        <ng-template pTemplate="caption">
                            <span class="text-sm text-color-secondary">
                                {{ automaticUnallocatedResults().length }} unallocated transaction(s)
                            </span>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Date</th>
                                <th>Reference</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                                <th>Bank</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-tx>
                            <tr>
                                <td>{{ tx.transactionDate | date:'dd MMM yyyy' }}</td>
                                <td>{{ tx.reference }}</td>
                                <td>{{ tx.description }}</td>
                                <td>{{ tx.debit | number:'1.2-2' }}</td>
                                <td>{{ tx.credit | number:'1.2-2' }}</td>
                                <td>{{ tx.balance | number:'1.2-2' }}</td>
                                <td>{{ tx.bank }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7" class="text-center p-4">
                                    Run automatic allocation on the previous tab to see results here.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>

        </p-tabView>
    </div>
</div>
